import { render, staticRenderFns } from "./RecuperarContraseña.vue?vue&type=template&id=fae95814&"
import script from "./RecuperarContraseña.vue?vue&type=script&lang=js&"
export * from "./RecuperarContraseña.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports